import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { useLegalDocument } from "../../pages/Legal/useLegalDocument";
import "../../pages/Legal/Legal.min.css";

/**
 * The /legal reader, in place: opened from a purchase confirmation so the
 * member reads the Termini e Condizioni or the Informativa Privacy without
 * leaving the plan they were about to buy.
 */
const LegalDocumentBody = ({ slug }) => {
  const { matcher, document, loading, fetchError } = useLegalDocument(slug);

  return (
    <div className="legal">
      {loading && !document && (
        <div className="legal__loading">
          <IonSpinner name="crescent" />
        </div>
      )}
      {!loading && !document && (
        <div className="legal__error">
          {fetchError && matcher
            ? "Impossibile caricare il documento. Riprova più tardi."
            : "Documento non disponibile."}
        </div>
      )}
      {document && (
        <article
          className="legal__content"
          // Same trusted CRM HTML the /legal page renders.
          dangerouslySetInnerHTML={{ __html: document.content || "" }}
        />
      )}
    </div>
  );
};

const TITLES = {
  terms: "Termini e Condizioni",
  "privacy-policy": "Informativa Privacy",
};

const LegalDocumentModal = ({ slug, onClose }) => (
  <IonModal isOpen={!!slug} onDidDismiss={onClose}>
    <IonHeader>
      <IonToolbar>
        <IonTitle>{TITLES[slug] ?? ""}</IonTitle>
        <IonButtons slot="end">
          <IonButton onClick={onClose}>Chiudi</IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      {/* Keyed so switching document fetches the right one. */}
      {slug ? <LegalDocumentBody key={slug} slug={slug} /> : null}
    </IonContent>
  </IonModal>
);

export default LegalDocumentModal;
